// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

export const SUI_DECIMALS = 9;
export const MIST_PER_SUI = BigInt(1000000000);

export const MOVE_STDLIB_ADDRESS =
	'0x0000000000000000000000000000000000000000000000000000000000000001';
export const SUI_FRAMEWORK_ADDRESS =
	'0x0000000000000000000000000000000000000000000000000000000000000002';
export const SUI_SYSTEM_ADDRESS =
	'0x0000000000000000000000000000000000000000000000000000000000000003';
export const SUI_CLOCK_OBJECT_ID =
	'0x0000000000000000000000000000000000000000000000000000000000000006';
export const SUI_SYSTEM_MODULE_NAME = 'sui_system';
export const SUI_TYPE_ARG = `${SUI_FRAMEWORK_ADDRESS}::sui::SUI`;
export const SUI_SYSTEM_STATE_OBJECT_ID =
	'0x0000000000000000000000000000000000000000000000000000000000000005';
export const SUI_RANDOM_OBJECT_ID =
	'0x0000000000000000000000000000000000000000000000000000000000000008';
export const SUI_COIN_REGISTRY_OBJECT_ID =
	'0x000000000000000000000000000000000000000000000000000000000000000c';
export const SUI_DENY_LIST_OBJECT_ID =
	'0x0000000000000000000000000000000000000000000000000000000000000403';
